// extracted by mini-css-extract-plugin
module.exports = {"adminDashboard":"AdminDashboard_adminDashboard__1Cor5","lastDays":"AdminDashboard_lastDays__2m41w"};